import useProfile from "hooks/useProfile";
import { useDispatch } from "react-redux";
import { updateProfileDataRequest } from "services/userFlagsService";
import { editUsersFlag } from "store/user";

const ProfileSound = ({ playSound }) => {
  const dispatch = useDispatch();
  const { flags } = useProfile();
  const isSoundOn = flags.sound;

  const updateSoundsStateInProfile = async () => {
    playSound("main");
    dispatch(editUsersFlag({ field: "sound", value: !isSoundOn }));
    try {
      await updateProfileDataRequest({ flags: { sound: !isSoundOn } });
    } catch (e) {
      console.log("error of changing view_expired_event in profile:", e);
    }
  };

  return (
    <li className="profile-content__settings-item">
      <b>Sound:</b>
      <input
        type="checkbox"
        id="sound"
        onChange={updateSoundsStateInProfile}
        checked={isSoundOn}
      />
      <label htmlFor="sound"></label>
    </li>
  );
};

export default ProfileSound;
